import React from 'react';

export default
<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g transform="translate(2.000000, 2.000000)">
        <circle className="thickness-line" fill="currentColor" cx="10" cy="10" r="1"></circle>
    </g>
</g>;